import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-7495ff46"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = ["src", "alt"];
export default /*#__PURE__*/_defineComponent({
  __name: 'CornerMark',
  props: {
    cornerInfo: null
  },
  setup: function (__props) {
    return function (_ctx, _cache) {
      var _a, _b;
      return _openBlock(), _createElementBlock("div", null, [__props.cornerInfo ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: (_a = __props.cornerInfo) === null || _a === void 0 ? void 0 : _a.src,
        alt: (_b = __props.cornerInfo) === null || _b === void 0 ? void 0 : _b.alt
      }, null, 8, _hoisted_1)) : _createCommentVNode("", true)]);
    };
  }
});